import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import { Checkbox, IconButton, RaisedButton, TextField, Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui';

import PortsTableRow from './Row';

import { getPorts } from 'actions/regions/ports';
import styles from 'styles';

class PortsListTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            ports: [],
            sort: 'name',
            query: props.ports.query,
            onlyChanged: false,
            loading: false,
        };

        this.handleChangeSearch = this.handleChangeSearch.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);

        this.isOnlyChanged = this.isOnlyChanged.bind(this);

    }

    isOnlyChanged() {
        this.setState({
            page: 1,
            onlyChanged: !this.state.onlyChanged,
        }, () => {
           this.changePortList({ });
        });
    }

    nextPage() {
        this.changePortList({ direction: 1 });
    }

    prevPage() {
        this.changePortList({ direction: -1 });
    }

    changePortList({ direction = undefined }) {
        let page = 1;

        if (typeof direction !== 'undefined' && this.props.ports.previous && direction < 0 ) {
            page = this.props.ports.previous;
        } else if (typeof direction !== 'undefined' && this.props.ports.next && direction > 0) {
            page = this.props.ports.next;
        }

        this.setState({
            loading: true,
        }, () => {
            this.props.getPorts({
                page,
                query: this.state.query,
                onlyChanged: this.state.onlyChanged,
                sort: this.state.sort,
            });
        });
    }

    handleChangeSearch(e, value) {
        this.setState({
            query: value,
        });
    }

    handleSearch() {
       this.changePortList({ });
    }

    UNSAFE_componentWillReceiveProps({ ports: { isLoaded, data: ports, page, query, onlyChanged }}) {
         this.setState({
             page,
             ports,
             query,
             onlyChanged,

             loading: !isLoaded,
         });
    }

    render() {
        const { query, onlyChanged, loading, page } = this.state;
        const { ports } = this.props;

        return (
            <Fragment>
                <div className='paper-block'>
                    <div className='row'>
                        <div className='col-xs-4 center-xs middle-xs' style={{display: 'flex'}}>
                            <TextField
                                defaultValue={query}
                                floatingLabelText='Search by name'
                                ref='search'
                                onChange={this.handleChangeSearch}
                                disabled={loading}
                                onKeyPress={(event) => {
                                    if (event.charCode === 13) {
                                        event.preventDefault();
                                        this.handleSearch();
                                    }
                                }}
                            />

                            <RaisedButton
                                label='Search'
                                style={styles.RaisedButton}
                                primary
                                disabled={loading}
                                onClick={this.handleSearch}
                            />
                        </div>
                        <div className="col-xs-4 start-xs middle-xs" style={{display: 'flex'}}>
                            <Checkbox
                                label={'Show only changed ports'}
                                checked={onlyChanged}
                                disabled={loading}
                                onCheck={this.isOnlyChanged}
                            />
                        </div>
                        <div className="col-xs-4 center-xs middle-xs" style={{display: 'flex'}}>
                            <RaisedButton
                                label='Create new port'
                                style={styles.RaisedButton}
                                primary
                                disabled={loading}
                                containerElement={<Link to='/regions/ports/add' />}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-xs-12 center-xs middle-xs" style={{display: 'flex'}}>

                            <IconButton
                                iconStyle={styles.navigationLeft}
                                name='navigationLeft'
                                onClick={this.prevPage}
                                disabled={loading}
                            >
                                <ChevronLeft />
                            </IconButton>
                            <div className='item'>Page: {page}</div>
                            <IconButton
                                iconStyle={styles.navigationRight}
                                name='navigationRight'
                                onClick={this.nextPage}
                                disabled={loading}

                            >
                                <ChevronRight />
                            </IconButton>
                        </div>
                    </div>
                </div>

                <div className='table-body'>
                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                    name
                                </TableHeaderColumn>

                                <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                    unLoCode
                                </TableHeaderColumn>

                                <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                    country
                                </TableHeaderColumn>

                                <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                    parent name
                                </TableHeaderColumn>

                                <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                    Actions
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                        <TableBody displayRowCheckbox={false}>
                            {
                                ports.data.map(item => <PortsTableRow
                                    key={item._id}
                                    item={item}
                                />)
                            }
                        </TableBody>
                    </Table>
                </div>
            </Fragment>
        );
    }
}

PortsListTable.propTypes = {
    ports: PropTypes.object,
    getPorts: PropTypes.func,
};

PortsListTable.defaultProps = {
    ports: {},
    getPorts: () => {
        console.error(`PortsListTable didn't find getPorts function`)
    },
};

export default connect(
    ({ ports }) => {
        return {
            ports,
        };
    },
    dispatch => bindActionCreators({
            getPorts,
        },
        dispatch),
)(PortsListTable);



// WEBPACK FOOTER //
// ./app/components/Regions/Ports/Table.jsx